import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useMessenger } from "./../../context/MessengerContext";
import { ThemeContext } from "./../../constant/theme";
import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";

// Ø§Ù„ØµÙØ­Ø§Øª
import EmployeesTableadmin from "../(admin)employeemanagement/EmployeeManagement.jsx";
import EmployeesTable from "../(Manager)employeemanagement/EmployeeManagementManager";
import Dashboard from "../(Admin) dashboard/index.js";
import Analytics from "../(All) ComingSoon/ComingSoon.js";
import Reports from "../(Admin) Reports/Reports.js";
import Calendar from "../(All) Calendar/index.jsx";
import Attendance from "../(Admin)Attendance";
import SettingsPage from "../(All) settings/settings.js";
import Mo3tiAdminDocumentRequests from "../(Admin)DocumentRequests/DocumentRequestsPage.jsx";
import ExcelSalaryProcessorWithTheme from "../(Admin and Manager) Taxcalculator";
import Payroll from "../(admin and manager) Payroll/index.jsx";
import SidebarWithTopbar from "../(All) Sidebar/SidebarWithTopbar";
import ViewTypeSwitcher from '../../components/ViewTypeSwitcher';
import Mo3tiAdvancementManagement from "../(Admin)AdvancementManagement/AdvancementManagementPage.jsx";
import LeaveApprovalPage from "../(Admin)leave_Managment/index.jsx";
import MessengerPage from "../(All) messenger/MessengerPage.jsx";
import EmployeeActionsPage from "../(Admin)EmployeeActions/EmployeeActionsPage.jsx";
import CompanyConfiguration from "../(SuperAdmin)ConfigurationManagement";
import { LanguageContext } from "../../constant/LanguageContext";
import { useModal } from '../../constant/ModalContext.jsx';
import { translations_Manager } from "../../constant/Admin_Translations.js";
import {
    Home,
    Users,
    CalendarCheck,
    MessageSquare,
    BookCheckIcon,
    Coffee,
    DollarSignIcon,
    GitPullRequestIcon,
    CreditCard,
    CalculatorIcon,
    LockIcon,
    Settings,
    CalendarIcon as CalendarIcon,
    Moon,
    Sun,
} from "lucide-react";

// constants
import { pageToModuleMap, adminOnlyPages } from "./constants/pageToModuleMap";

// hooks
import useLocationAccess from "./hooks/useLocationAccess";
import useModulePermissions from "./hooks/useModulePermissions";
import useUnreadMessages from "./hooks/useUnreadMessages";
import useMetricsFetch from "./hooks/useMetricsFetch";
import useSyncPageWithRoute from "./hooks/useSyncPageWithRoute";

// components
import BackgroundBlobs from "./components/BackgroundBlobs";

// renderers
import { renderCurrentPage } from "./renderers/pageRenderer";

function ProfessionalDashboardManager() {
    // Ø³ÙŠØ§Ù‚ Ø§Ù„Ø«ÙŠÙ…
    const { theme, setTheme } = useContext(ThemeContext);

    // Ø§Ù„Ù„ØºØ© Ø§Ù„Ø­Ø§Ù„ÙŠØ©
    const { language = 'en' } = useContext(LanguageContext);
    const isRTL = language === 'ar';
    const t = translations_Manager[language] || translations_Manager['ar'];

    // hooks
    const { userLocation, locationError } = useLocationAccess(t);

    const [employeeCount, setEmployeeCount] = useState(0);
    const [counts, setCounts] = useState({ Active: 0, OnLeave: 0, Recent: 0, TotalCompanies: 0 });
    const [departmentStats, setDepartmentStats] = useState([]);
    const [viewType, setViewType] = useState(() => {
        return localStorage.getItem('managerViewType') || 'manager';
    });

    useEffect(() => {
        try {
            const storedRole = (localStorage.getItem('role') || '').toLowerCase();
            const adminLevelRaw = localStorage.getItem('adminLevel');
            let hasAdmin = false;

            if (adminLevelRaw) {
                try {
                    const parsed = JSON.parse(adminLevelRaw);
                    hasAdmin = Boolean(
                        parsed?.adminLevelId ||
                        parsed?.admin_level_id ||
                        (Array.isArray(parsed?.modules) && parsed.modules.length > 0)
                    );
                } catch (parseError) {
                    console.warn('Failed to parse admin level during view enforcement:', parseError);
                }
            }

            if (storedRole === 'manager' && !hasAdmin) {
                if (localStorage.getItem('managerViewType') !== 'manager') {
                    localStorage.setItem('managerViewType', 'manager');
                    localStorage.setItem('viewType', 'manager');
                }
                setViewType('manager');
            }
        } catch (error) {
            console.warn('Failed to enforce default manager view:', error);
        }
    }, []);

    const BASE_URL = process.env.REACT_APP_BASE_URL;

    // Check if user has an admin level assigned
    const hasAdminLevel = () => {
        try {
            const adminLevelData = localStorage.getItem('adminLevel');
            if (adminLevelData) {
                const adminLevel = JSON.parse(adminLevelData);
                return adminLevel && (adminLevel.modules?.length > 0 || adminLevel.adminLevelId);
            }
        } catch (e) {
            console.error('Error checking admin level:', e);
        }
        return false;
    };

    // Fetch dashboard metrics
    useMetricsFetch({
        BASE_URL,
        viewType,
        hasAdminLevel,
        setEmployeeCount,
        setCounts,
        setDepartmentStats,
    });

    // Ù…Ø¹Ù„ÙˆÙ…Ø§Øª Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù… Ù…Ù† localStorage
    const [user] = useState({
        username: localStorage.getItem("emoloyeeName"),
        email: localStorage.getItem("email"),
        role: localStorage.getItem("role"),
    });

    const [notifications, setNotifications] = useState(3);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [currentPage, setCurrentPage] = useState('dashboard');

    // Call hooks at top level
    const navigate = useNavigate();
    const auth = useAuth();
    const { conversations: messengerConversations, socket, isConnected } = useMessenger();
    const { logout, hasModuleAccess } = auth;
    const { showModal } = useModal();

    // Unread messages hook
    const { unreadMessages } = useUnreadMessages({
        BASE_URL,
        socket,
        isConnected,
        messengerConversations,
    });

    // Module permissions hook
    const { modulePermissions } = useModulePermissions(BASE_URL);

    // "Communicator Module (PTT & Private Messages)" is the umbrella toggle a
    // superadmin actually reaches for in Communication Modules — it wasn't
    // wired to anything, so flipping it left the Messenger page locked unless
    // the separate, easy-to-miss "Private Messaging" sub-toggle was ALSO set.
    const isPrivateMessagingEnabled =
      (modulePermissions?.privateMessaging || modulePermissions?.communicatorModule) ?? false;

    // Reset currentPage when viewType changes
    useEffect(() => {
        setCurrentPage('dashboard');

        if (viewType === 'admin') {
            console.log('ðŸ” Admin View Mode Active');
            console.log('Admin Level Data (raw):', localStorage.getItem('adminLevel'));
            try {
                const adminLevel = JSON.parse(localStorage.getItem('adminLevel'));
                console.log('Parsed Admin Level:', adminLevel);
                console.log('Available Modules:', adminLevel?.modules);
                console.log('Module names:', adminLevel?.modules?.map(m => m.moduleName || m.name || m));
            } catch (e) {
                console.error('Error parsing adminLevel:', e);
            }

            console.log('AuthContext permissions:', auth.permissions);
            console.log('AuthContext user:', auth.user);
        }
    }, [viewType, auth]);

    const handleViewTypeChange = (type) => {
        try {
            if (type) {
                localStorage.setItem('managerViewType', type);
                localStorage.setItem('viewType', type);
            }
        } catch (error) {
            console.warn('Failed to persist view type selection:', error);
        }

        if (type === 'user') {
            // Navigating away from this page entirely — skip setViewType so the
            // sidebar here doesn't re-render (filtered down to 2 items) before
            // the router swaps in the user profile page.
            if (hasAdminLevel() && user.role === 'admin') {
                navigate("/userprofileadmin/professionalProfile");
            } else {
                navigate("/userprofilemanager/professionalProfile");
            }
            return;
        }

        setViewType(type);

        if (type === 'manager') {
            setCurrentPage('dashboard');
        } else if (type === 'admin') {
            setCurrentPage('dashboard');
            navigate("/DashboardManager/dashboard");
        }
    };

    // Ø§Ù„ØªØ¨Ø¯ÙŠÙ„ Ø¨ÙŠÙ† Ø§Ù„Ø«ÙŠÙ… Ø§Ù„ÙØ§ØªØ­ ÙˆØ§Ù„Ø¯Ø§ÙƒÙ†
    const toggleTheme = () => {
        const newTheme = theme === "light" ? "dark" : "light";
        setTheme(newTheme);
    };

    // Ø¯Ø§Ù„Ø© ØªØ³Ø¬ÙŠÙ„ Ø§Ù„Ø®Ø±ÙˆØ¬
    const handleLogout = () => {
        try {
            logout();
            try {
                localStorage.removeItem('nav_admin');
                localStorage.removeItem('nav_manager');
                localStorage.removeItem('nav_employee');
            } catch (e) { }
            navigate("/login");
        } catch (error) {
            console.error("Ø®Ø·Ø£ ÙÙŠ ØªØ³Ø¬ÙŠÙ„ Ø§Ù„Ø®Ø±ÙˆØ¬:", error);
            navigate("/login");
        }
    };

    // Ø§Ù„ØªØ¨Ø¯ÙŠÙ„ Ø¥Ù„Ù‰ Ø­Ø³Ø§Ø¨ Ø§Ù„Ù…ÙˆØ¸Ù
    const handleSwitchEmployee = () => {
        try {
            localStorage.removeItem('adminCurrentPage');
            setCurrentPage('dashboard');
            navigate("/userprofilemanager/professionalProfile");
        } catch (error) {
            console.error("Ø®Ø·Ø£ ÙÙŠ Ø§Ù„ØªØ¨Ø¯ÙŠÙ„:", error);
            navigate("/DashboardManager");
        }
    };

    // Ø¹Ù†Ø§ØµØ± Ù‚Ø§Ø¦Ù…Ø© Ø§Ù„ØªÙ†Ù‚Ù„
    const allNavItems = [
        { icon: Home, text: t.dashboard, page: "dashboard" },
        { icon: Users, text: t.employees, page: "employees" },
        { icon: CalendarCheck, text: t.attendance, page: "attendance" },
        { icon: CalendarIcon, text: t.calendar, page: "calendar" },
        {
            icon: MessageSquare,
            text: isPrivateMessagingEnabled ? t.messages : t.messagesLocked,
            page: "messages",
            locked: !isPrivateMessagingEnabled,
            badge: unreadMessages,
            badgeColor: '#ef4444',
        },
        { icon: BookCheckIcon, text: t.documentsManagement, page: "Mo3tiAdminDocumentRequests" },
        { icon: Coffee, text: t.leaveManagement, page: "LeaveApprovalPage" },
        { icon: DollarSignIcon, text: t.solfaManagement, page: "Mo3tiAdvancementManagement" },
        { icon: GitPullRequestIcon, text: t.employeeChanges, page: "ChangesPage" },
        { icon: CreditCard, text: t.payroll, page: "Payroll" },
        { icon: CalculatorIcon, text: t.taxCalculator, page: "TaxCalculator" },
        { icon: LockIcon, text: t.companyConfiguration, page: "companyConfig" },
        { icon: Settings, text: t.settingsLocked, page: "Settings" },
    ];

    // ØªØºÙŠÙŠØ± Ø§Ù„ØµÙØ­Ø© Ø§Ù„Ø­Ø§Ù„ÙŠØ©
    const handlePageChange = (page) => {
        const navItem = navItems.find(item => item.page === page);
        if (navItem?.locked) {
            const title = (t && t.notice) || 'Notice';
            const message = navItem.lockMessage || undefined;
            showModal({ title, message, options: { requestAccessEndpoint: process.env.REACT_APP_BASE_URL ? `${process.env.REACT_APP_BASE_URL}/api/request-module-access` : null, module: navItem.page } });
            return;
        }
        setCurrentPage(page);
        navigate(`/DashboardManager/${page}`);
    };

    // Sync currentPage with URL
    useSyncPageWithRoute({ allNavItems, currentPage, setCurrentPage });

    // Filter navigation items based on viewType
    const navItems = allNavItems.filter(item => {
        if (item.page === "dashboard" || item.page === "Settings") return true;
        if (user.role === "superadmin") return true;
        if (adminOnlyPages.includes(item.page) && (viewType === 'user' || viewType === 'manager')) {
            return false;
        }
        if (viewType === 'user') return false;
        if (viewType === 'manager') return !adminOnlyPages.includes(item.page);
        if (viewType === 'admin') {
            const requiredModule = pageToModuleMap[item.page];
            if (!requiredModule) return true;
            const hasAccess = hasModuleAccess(requiredModule);
            console.log(`Admin Mode - Page: ${item.page}, Module: ${requiredModule}, Access: ${hasAccess}`);
            return hasAccess;
        }
        return true;
    });

    // ---- render helpers ----
    const renderDashboard = () => (
        <Dashboard employeeCount={employeeCount} counts={counts} departmentStats={departmentStats} />
    );
    const renderEmployees = () => {
        if (viewType === 'admin') return <EmployeesTableadmin />;
        return (
            <EmployeesTable
                onCountsUpdate={(updatedCounts) => {
                    if (updatedCounts && typeof updatedCounts === "object") {
                        setCounts((prev) => ({ ...prev, ...updatedCounts }));
                    }
                }}
                onEmployeeCountUpdate={(total) => {
                    if (typeof total === "number") setEmployeeCount(total);
                }}
            />
        );
    };
    const renderAttendance = () => <Attendance />;
    const renderAnalytics = () => <Analytics />;
    const renderReports = () => <Reports />;
    const renderCalendar = () => <Calendar />;
    const renderSettings = () => <SettingsPage />;
    const renderMo3tiAdminDocumentRequests = () => <Mo3tiAdminDocumentRequests />;
    const renderMo3tiAdvancementManagement = () => <Mo3tiAdvancementManagement />;
    const renderAdminLeavePage = () => <LeaveApprovalPage />;
    const renderChangesPage = () => <EmployeeActionsPage />;
    const renderPayroll = () => <Payroll />;
    const renderTaxCalculator = () => <ExcelSalaryProcessorWithTheme />;
    const renderCompanyConfig = () => <CompanyConfiguration />;

    // Ø§Ù„Ø¹Ø±Ø¶ Ø§Ù„Ø±Ø¦ÙŠØ³ÙŠ
    return (
        <div
            style={{
                minHeight: "100vh",
                fontFamily: "Segoe UI, Roboto, sans-serif",
                position: "relative",
                direction: isRTL ? "rtl" : "ltr",
            }}
        >
            <BackgroundBlobs theme={theme} />

            <SidebarWithTopbar
                navItems={navItems}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                user={user}
                notifications={notifications}
                handleLogout={handleLogout}
                handleSwitchEmployee={handleSwitchEmployee}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                themeToggle={
                    <button
                        style={{
                            padding: "8px",
                            borderRadius: "12px",
                            cursor: "pointer",
                            color: theme === "light" ? "#0f172a" : "white",
                            background: theme === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
                        }}
                        onClick={toggleTheme}
                    >
                        {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
                    </button>
                }
                viewModeSwitcher={
                    <ViewTypeSwitcher
                        viewType={viewType}
                        onSelect={(type) => handleViewTypeChange(type)}
                        hasAdminLevel={() => hasAdminLevel()}
                        role={user.role}
                    />
                }
            >
                <div style={{
                    padding: "0",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    marginTop: currentPage === 'messages' ? '0' : '40px',
                    direction: isRTL ? "rtl" : "ltr",
                }}>
                    <Routes>
                        <Route path="/dashboard" element={renderDashboard()} />
                        <Route path="/employees" element={renderEmployees()} />
                        <Route path="/attendance" element={renderAttendance()} />
                        <Route path="/analytics" element={renderAnalytics()} />
                        <Route path="/reports" element={renderReports()} />
                        <Route path="/calendar" element={renderCalendar()} />
                        <Route
                            path="/messages"
                            element={
                                modulePermissions === null ? (
                                    <div style={{ padding: 20, textAlign: "center" }}>Loading...</div>
                                ) : isPrivateMessagingEnabled ? (
                                    <MessengerPage />
                                ) : (
                                    <Navigate to="/DashboardManager/dashboard" replace />
                                )
                            }
                        />
                        <Route path="/Mo3tiAdminDocumentRequests" element={renderMo3tiAdminDocumentRequests()} />
                        <Route path="/Mo3tiAdvancementManagement" element={renderMo3tiAdvancementManagement()} />
                        <Route path="/Payroll" element={renderPayroll()} />
                        <Route path="/TaxCalculator" element={renderTaxCalculator()} />
                        <Route path="/LeaveApprovalPage" element={renderAdminLeavePage()} />
                        <Route path="/ChangesPage" element={renderChangesPage()} />
                        <Route path="/companyConfig" element={renderCompanyConfig()} />
                        <Route path="/Settings" element={renderSettings()} />
                        <Route path="*" element={<Navigate to="/DashboardManager" replace />} />
                    </Routes>
                </div>
            </SidebarWithTopbar>
        </div>
    );
}

export default ProfessionalDashboardManager;